import { HttpClient } from '@angular/common/http';
import { Component, inject, Input, OnChanges, OnInit, signal, SimpleChanges, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SvgIcon } from '@k12/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-svg-icon',
  imports: [],
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss'
})
export class SvgIconComponent implements OnInit, OnChanges {
  @Input() svgHeight: string = '85px';
  @Input() svgName: string;
  @Input() svgWidth: string = '85px';

  public svgContent: WritableSignal<SafeHtml> = signal('');

  private readonly http: HttpClient = inject(HttpClient);
  private readonly sanitizer: DomSanitizer = inject(DomSanitizer);
  private svgPath: string;

  // Icon to path mapping
  private readonly iconPathMap: Record<string, string> = {
    [SvgIcon.Bus]: 'assets/images/green_bus.svg',
    [SvgIcon.Giving]: 'assets/images/green_giving.svg',
    [SvgIcon.Lightbulb]: 'assets/images/green_lightbulb.svg',
    [SvgIcon.Cap]: 'assets/images/green_cap.svg',
    [SvgIcon.Household]: 'assets/images/green_household.svg',
    [SvgIcon.Document]: 'assets/images/green_document.svg',
    [SvgIcon.Tutoring]: 'assets/images/tutoring.svg',
    [SvgIcon.Tutor]: 'assets/images/tutor.svg',
    [SvgIcon.Therapy]: 'assets/images/therapy.svg',
    [SvgIcon.Transportation]: 'assets/images/transportation.svg',
    [SvgIcon.WarningBlack]: 'assets/images/warning-black.svg',
    [SvgIcon.InfoBlue]: 'assets/images/info-blue.svg',
    [SvgIcon.ErrorRed]: 'assets/images/error-red.svg',
    [SvgIcon.TrashCan]: 'assets/images/trash-can.svg',
    [SvgIcon.SuccessGreen]: 'assets/images/success-green.svg',
    [SvgIcon.Users]: 'assets/images/users.svg',
    [SvgIcon.ClipboardUsers]: 'assets/images/clipboard-users.svg',
    [SvgIcon.ClipboardList]: 'assets/images/clipboard-list.svg',
    [SvgIcon.ChevronRight]: 'assets/images/breadcrumb-chevron.svg',
    [SvgIcon.ChevronUp]: 'assets/images/chevron-up.svg',
    [SvgIcon.ChevronDown]: 'assets/images/chevron-down.svg',
    [SvgIcon.BlueCheck]: 'assets/images/blue-check.svg',
    [SvgIcon.Messages]: 'assets/images/messages.svg',
    [SvgIcon.Messaging]: 'assets/images/messaging.svg',
    [SvgIcon.Edit]: 'assets/images/edit.svg',
    [SvgIcon.HourglassClock]: 'assets/images/hourglass-clock.svg',
    [SvgIcon.HandMoney]: 'assets/images/hand-money.svg',
    [SvgIcon.FloppyDisk]: 'assets/images/floppy-disk.svg',
    [SvgIcon.PaperClip]: 'assets/images/paper-clip.svg',
    [SvgIcon.CommunicationTemplateAlertBanner]: 'assets/images/alert-communication-template.svg',
    [SvgIcon.CommunicationTemplateEmail]: 'assets/images/email-communication-template.svg',
    [SvgIcon.EmailTemplate]: 'assets/images/email-template.svg',
    [SvgIcon.EmailNotification]: 'assets/images/email-notification.svg',
    [SvgIcon.EmailUsers]: 'assets/images/email-users.svg',
    [SvgIcon.CircleSuccess]: 'assets/images/circle-success.svg',
    [SvgIcon.isPrimary]: 'assets/images/is-primary.svg',
    [SvgIcon.isNotPrimary]: 'assets/images/is-not-primary.svg',
    [SvgIcon.EyeView]: 'assets/images/eye-view.svg'
  };

  // TODO: Please update each time a new icon is added
  public ngOnInit(): void {
    this.setSvgImage(this.svgName);
    this.setSanitizedSvg();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['svgName'] && changes['svgName'].currentValue !== changes['svgName'].previousValue) {
      this.setSvgImage(changes['svgName'].currentValue);
      this.setSanitizedSvg();
    }
  }

  private setSanitizedSvg(): void {
    this.http.get(this.svgPath, { responseType: 'text' }).subscribe({
      next: (response) => {
        // Add height and width attributes to the SVG
        const svgWithDimensions = response.replace('<svg', `<svg height="${this.svgHeight}" width="${this.svgWidth}"`);
        this.svgContent.set(this.sanitizer.bypassSecurityTrustHtml(svgWithDimensions));
      },
      error: (error) => console.error(error)
    });
  }

  private setSvgImage(imageName: string): void {
    this.svgPath = this.iconPathMap[imageName] ?? 'assets/images/default_icon.svg';
  }
}
